function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "19h9t42jca"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 1.000000 0"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#19h9t42jca)",
  transform: "translate(-1938 -841) translate(1922 825)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(16 16)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M3.225 2.414l.019.047c.033.066.076.127.131.182L21.053 20.32c.067.067.145.118.228.152.109.251.059.555-.148.762l-.198.198c-.274.273-.717.273-.99 0l-3.275-3.274c-1.977 2.183-4.042 3.589-4.17 3.674-.167.084-.333.167-.5.167-.167 0-.333-.083-.5-.167-.026-.017-.13-.088-.297-.207l-.186-.137c-1.715-1.267-7.35-5.84-7.35-11.156 0-1.485.394-2.884 1.082-4.095L2.267 3.755c-.273-.273-.273-.716 0-.99l.198-.198c.206-.205.507-.256.76-.153zm2.758 5.057c-.416.869-.65 1.84-.65 2.862 0 4.5 5.084 8.667 6.667 9.834.716-.528 2.148-1.669 3.501-3.177l-3.328-3.329-.173.006c-1.772 0-3.233-1.402-3.328-3.151l-.005-.183c0-.058.001-.116.004-.174L5.983 7.471zM12 2c4.583 0 8.333 3.75 8.333 8.333 0 1.869-.696 3.645-1.673 5.219l-1.206-1.205c.723-1.253 1.213-2.617 1.213-4.014 0-3.666-3-6.666-6.667-6.666-1.468 0-2.829.48-3.934 1.292L6.88 3.771C8.295 2.662 10.074 2 12 2zm0 5c1.833 0 3.333 1.5 3.333 3.333 0 .548-.133 1.065-.37 1.522l-1.31-1.31c.01-.07.014-.14.014-.212 0-.916-.75-1.666-1.667-1.666-.071 0-.142.004-.21.013l-1.312-1.31C10.935 7.134 11.453 7 12 7z",
  transform: "translate(16 16)"
})))));
function SvgLocationOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOff);
export default __webpack_public_path__ + "static/media/location-off.9852b48e1e7f90276a8790b77dd1aa63.svg";
export { ForwardRef as ReactComponent };